import { ITEM_SOURCE_NOTE, ITEM_SOURCE_NOTE_SEPARATOR } from '../constants/reports';
import { ItemSourceEnum } from '../types/marketplace';

export const getItemSourceNote = (sources: ItemSourceEnum[], warehouseNames: string): string =>
  sources
    .map((source) => (source === ItemSourceEnum.IeWarehouse ? warehouseNames : ITEM_SOURCE_NOTE[source]))
    .filter((part) => !!part)
    .join(ITEM_SOURCE_NOTE_SEPARATOR);
